interface LoadingSkeletonProps {
  rows?: number
  className?: string
}

export default function LoadingSkeleton({ rows = 6, className }: LoadingSkeletonProps) {
  return (
    <div className={`animate-pulse space-y-3 ${className ?? ''}`} aria-label="Loading">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="h-10 bg-gray-200 dark:bg-gray-700 rounded"
          style={{ width: `${85 + (i % 3) * 5}%` }}
        />
      ))}
    </div>
  )
}
